export const getConnectedFileExtension = (fileExt: string) => {
  if (fileExt?.includes("google_drive")) {
    return "Google Drive";
  }
  if (fileExt?.includes("teamwork_cloud")) {
    return "Teamwork Cloud";
  }
  if (fileExt?.includes("windchill")) {
    return "Windchill";
  }
  if (fileExt?.includes("3d_experience")) {
    return "3DEXPERIENCE";
  }
  if (fileExt?.includes("microsoft_365")) {
    return "Microsoft 365";
  }
  return fileExt;
};

export const getFileNameAndExtension = (fileName: string | null | undefined) => {
  if (!fileName) {
    return null;
  }
  const trimInd = fileName.lastIndexOf(".");
  if (trimInd === -1) {
    return { extension: "", name: fileName };
  }
  return {
    extension: fileName.substring(trimInd + 1),
    name: fileName.substring(0, trimInd),
  };
};

// Backend sends file extensions inconsistently: dotless ("glb") or dotted (".glb"), and any casing.
// Callers compare against a bare, lowercase form, so coerce to that and treat blank input as absent.
export const normalizeFileExtension = (extension: string | null | undefined): string | undefined => {
  const trimmed = extension?.trim();
  if (!trimmed) return undefined;
  const withoutDot = trimmed.startsWith(".") ? trimmed.slice(1) : trimmed;
  return withoutDot ? withoutDot.toLowerCase() : undefined;
};

// Strips the file extension from a display name if it ends with that extension.
// Handles extensions with or without a leading dot (e.g., "xlsx" or ".xlsx").
export const stripExtensionFromDisplayName = (
  displayName: string | null | undefined,
  extension: string | null | undefined,
): string | undefined => {
  if (!displayName) return undefined;
  if (!extension) return displayName;
  const normalizedExt = extension.startsWith(".") ? extension.slice(1) : extension;
  if (normalizedExt && displayName.toLowerCase().endsWith(`.${normalizedExt.toLowerCase()}`)) {
    return displayName.slice(0, -(normalizedExt.length + 1));
  }
  return displayName;
};

export const checkIsLinkedModel = (extension: string | undefined): boolean => {
  if (!extension) {
    return false;
  }
  return extension.startsWith("istari") && extension.includes("metadata");
};

export const getLiteralModelName = (extension: string | undefined): string | undefined => {
  switch (extension) {
    case "catpart":
    case "catproduct":
      return "Catia";
    case "mdzip":
      return "Cameo";
    case "xlsx":
      return "Excel";
    default:
      return getConnectedFileExtension(extension!);
  }
};

export const getExtractableFileType = (extension: string): string => {
  switch (extension) {
    case "catpart":
    case "catproduct":
      return "catia";
    case "docx":
      return "word";
    case "mdzip":
      return "cameo";
    case "xlsx":
    case "csv":
      return "excel";
    default:
      return extension;
  }
};

export const getAppHostFromExt = (ext: string | null | undefined) =>
  ext ? ext.match(/istari_(.*)_metadata.*/)?.[1] : undefined;

export function isZipFile(extension?: string): boolean {
  return !!extension && extension.toLowerCase() === "zip";
}
